import { render, staticRenderFns } from "./childEditor.vue?vue&type=template&id=bda6047e&scoped=true"
import script from "./childEditor.vue?vue&type=script&lang=js"
export * from "./childEditor.vue?vue&type=script&lang=js"
import style0 from "./childEditor.vue?vue&type=style&index=0&id=bda6047e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda6047e",
  null
  
)

export default component.exports